import { render, staticRenderFns } from "./Tolerations.vue?vue&type=template&id=c4b61f4c&scoped=true&"
import script from "./Tolerations.vue?vue&type=script&lang=js&"
export * from "./Tolerations.vue?vue&type=script&lang=js&"
import style0 from "./Tolerations.vue?vue&type=style&index=0&id=c4b61f4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b61f4c",
  null
  
)

export default component.exports